import React from 'react';
import { useInvalidSection } from '../metroline/invalid-section';
import { useSubscriberGroupsConfiguration, getSubscriberGroupsRoute } from '../metroline/subscriber-group-configuration';
import { SubscriberGroupItem } from '../types-store';
import { SubscriberGroupFormProps } from '../types';
import { SubscriberGroupsFormRenderer } from './subscriber-group-form-renderer';

export const SubscriberGroupFormSections: React.FC<SubscriberGroupFormProps> = ({
  actionType, formState, mainLanguage, options, section, locale, translation,
  showTranslations, shouldPrompt,
  changeLanguage, copyLanguageToAll, changeLongDescription, copyLongDescriptionToAll,
  saveSubscriberGroup, updateValidation, displayError,
  updateItem, switchTranslationsToggle, updateExternalMemberItem, removeExternalMember,
  addExternalMember, resetValidation, removeAllExternalMembers, mergeSubscriberGroupItem
}) => {

  const scrollViewUrl = getSubscriberGroupsRoute(actionType, formState.subscriberGroupItem?.id);

  const configuration = useSubscriberGroupsConfiguration(
    actionType,
    formState.subscriberGroupItem?.id,
    formState.validation
  );

  const [invalidSection, updateInvalidSection] = useInvalidSection(configuration, formState.validation);

  const onSaveSubscriberGroup = (subscriberGroup: SubscriberGroupItem) => {
    updateInvalidSection(undefined);
    saveSubscriberGroup(subscriberGroup);
  };

  return <SubscriberGroupsFormRenderer
    showTranslations={showTranslations}
    switchTranslationsToggle={switchTranslationsToggle}
    actionType={actionType}
    formState={formState}
    shouldPrompt={shouldPrompt}
    mainLanguage={mainLanguage}
    saveSubscriberGroup={onSaveSubscriberGroup}
    updateItem={updateItem}
    changeLanguage={changeLanguage}
    copyLanguageToAll={copyLanguageToAll}
    changeLongDescription={changeLongDescription}
    copyLongDescriptionToAll={copyLongDescriptionToAll}
    options={options}
    updateValidation={updateValidation}
    displayError={displayError}
    locale={locale}
    validation={formState.validation}
    translation={translation}
    label={translation.subscriber_groups_title}
    section={section}
    initialSection={section}
    configuration={configuration}
    scrollViewUrl={scrollViewUrl}
    invalidSection={invalidSection}
    removeExternalMember={removeExternalMember}
    addExternalMember={addExternalMember}
    removeAllExternalMembers={removeAllExternalMembers}
    updateExternalMemberItem={updateExternalMemberItem}
    mergeSubscriberGroupItem={mergeSubscriberGroupItem}
    resetValidation={resetValidation} />;
};
